import { Components, Theme } from '@mui/material';

export default {
  styleOverrides: {},
} as Components<Theme>['MuiInputBase'];
